/**
 * Attempts to parse and format data into a JSON object.
 * Handles both string JSON and object inputs.
 *
 * @param data - The data to format (string, object, or any other type)
 * @returns A parsed JSON object if successful, or null if parsing fails or data is invalid
 */
export const formatJson = (data: unknown): object | null => {
  if (!data) {
    return null;
  }

  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }

  if (typeof data === "object") {
    return data;
  }

  return null;
};
